import React from 'react'
import DummyCard from './dummyCard';
import './merge-profile.css';
import { useState, useEffect, useContext } from 'react';
import api from '../../service/api';
import { useParams } from "react-router-dom";
import Profile from '../raise-access/profile';
import { Alert, AlertTitle, Stack } from '@mui/material';
import ProgressBar from '../progress/progressBar';
import Backdrop from '@mui/material/Backdrop';
import { Tooltip, IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useHistory } from "react-router-dom";
import CONSTANT from '../../Constant/Constant';
import { DirectionContext } from '../../context/DirectionProvider';

const TrackMergeDetail = (props) => {

    const direction = useContext(DirectionContext)

    const [errorFlag, setErrorFlag] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [requestDetail, setRequestDetail] = useState([]);
    const params = useParams();
    const [loserDetail, setLoserDetail] = useState([]);
    const [winnerDetail, setWinnerDetail] = useState([]);
    const [user, setUser] = useState([]);
    const [isLoading, setIsloading] = useState(true);
    const [noData, setNoData] = useState(false)
    const [open] = React.useState(false);
    const history = useHistory();


    const goToDetails = () => {

    }

    const goBack = () => {
        history.goBack()
    }

    const getStatusClass = (state) => {
        switch (state) {
            case CONSTANT.STATE[0]:
                return 'text-white rounded py-2 px-3 bg-primary';
            case CONSTANT.STATE[1]:
                return 'text-white rounded py-2 px-3 bg-success';
            case CONSTANT.STATE[2]:
                return 'text-white rounded py-2 px-3 bg-danger';
            case CONSTANT.STATE[3]:
                return 'text-white rounded py-2 px-3 bg-warning';
            case CONSTANT.STATE[4]:
                return 'text-white rounded py-2 px-3 bg-primary';
            case CONSTANT.STATE[5]:
                return 'text-white rounded py-2 px-3 bg-success';
            case CONSTANT.STATE[6]:
                return 'text-white rounded py-2 px-3 bg-danger';
            case CONSTANT.STATE[7]:
                return 'text-white rounded py-2 px-3 bg-success';
            case CONSTANT.STATE[8]:
                return 'text-white rounded py-2 px-3 bg-warning';
            case 'AWAITING_REVIEW':
                return 'text-white rounded py-2 px-3 bg-primary';
            default:
                return 'text-white rounded py-2 px-3 bg-primary';
        }
    }

    useEffect(() => {

        //getting data using graph api
        api.getUserRole().then((response) => {

            setUser(response.data)

        })

            .catch((error) => {

                let errorDetail = error;
                let msg = errorDetail.response ? errorDetail.response.data.errorCode : 'Internal Server Error!';
                setErrorMsg(msg ? msg : 'Internal Server Error!');
                setErrorFlag(true);
                setIsloading(false)

            })

        //getting  merge request using id 
        api.getMergeRequest(params.id).then((res) => {
            if (res && res.data && res.data.data && ( res.data.data.winner ? res.data.data?.winner.length > 0 : res.data.data?.Winner.length > 0)) {
                setRequestDetail(res.data.data);
                setWinnerDetail(res.data.data?.winner || res.data.data?.Winner );
                setLoserDetail(res.data.data?.losers || res.data.data?.Loser);
                setIsloading(false)
            }
            else {
                setNoData(true)
                setIsloading(false)
            }

        }).catch((error) => {
            let errorDetail = error;
            let msg = errorDetail.response ? errorDetail.response.data.errorCode : 'Internal Server Error!';
            setErrorMsg(msg ? msg : 'Internal Server Error!');
            setErrorFlag(true);
            setIsloading(false)

        })


    }, [params.id])

    return (<div className="extra-margin-top-less container w-80 body-height min-width">

        {
            isLoading && !errorFlag &&
            <div className="d-flex justify-content-center extra-margin-top">
                <ProgressBar />
            </div>
        }


        {user && user.countries && winnerDetail.length > 0 && loserDetail.length > 0 && !errorFlag && !noData &&
            <>

                {(user && (user?.countries?.includes(requestDetail?.country || requestDetail?.Country))) || (user?.countries?.includes('global')) ?
                    (winnerDetail.length > 0 && loserDetail.length > 0 && !errorFlag &&

                        <div>
                            <div className="row">
                                <div className='col-11' id="request-header">
                                    <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
                                        <Tooltip disableFocusListener title="Back" id='tltipStrictSearchChckbx'>
                                            <IconButton aria-label="delete" onClick={goBack} className="text-danger" color="secondary">
                                                <ArrowBackIcon sx={{transform:direction==='rtl'?'rotate(180deg)':''}}/>
                                            </IconButton>
                                        </Tooltip>
                                        <div data-wg-notranslate className={getStatusClass(requestDetail.status || requestDetail.DcrStatus)}>{(requestDetail.status || requestDetail.DcrStatus) === 'AWAITING_REVIEW' ? 'AWAITING REVIEW' : (requestDetail.status || requestDetail.DcrStatus)}</div>
                                    </Stack>
                                    
                                    {
                                        requestDetail.VendorName === 'EPH'
                                            ? <div style={{ color: 'rgba(33, 37, 41, 0.75)', padding: '50px 0px 10px 0px' }}>
                                                <span style={{ fontWeight: 'bold' }}>Managed By: </span>Lilly
                                            </div>
                                            : requestDetail.VendorName &&
                                            <div style={{ color: 'rgba(33, 37, 41, 0.75)', padding: '50px 0px 10px 0px' }}>
                                                <span style={{ fontWeight: 'bold' }}>Managed By: </span>{requestDetail.VendorName}
                                            </div>
                                    }
                                     {
                                        requestDetail.Id &&
                                        <div style={{ color: 'rgba(33, 37, 41, 0.75)', padding: '0px 0px 10px 0px' }}><span style={{ fontWeight: 'bold' }}>Request Id: </span><span className="_wg-exclude">{requestDetail.Id}</span></div>
                                    }
                                    {
                                        requestDetail.CreatedBy &&
                                        <div style={{ color: 'rgba(33, 37, 41, 0.75)', padding: '0px 0px 10px 0px' }}><span style={{ fontWeight: 'bold' }}>Requestor Id: </span><span className="_wg-exclude">{requestDetail.CreatedBy}</span></div>
                                    }
                                    {
                                        requestDetail.RequestorName &&
                                        <div style={{ color: 'rgba(33, 37, 41, 0.75)', padding: '0px 0px 10px 0px' }}><span style={{ fontWeight: 'bold' }}>Requestor Name: </span><span className="_wg-exclude">{requestDetail.RequestorName.includes(" - Network") ? requestDetail.RequestorName.split(" - Network")[0].trim() : requestDetail.RequestorName}</span></div>
                                    }
                                    {
                                        (requestDetail?.RequestorEmail || requestDetail?.UserEmail) &&
                                        <div style={{ color: 'rgba(33, 37, 41, 0.75)', padding: '0px 0px 10px 0px' }}><span style={{ fontWeight: 'bold' }}>Requestor Email: </span><span className="_wg-exclude">{requestDetail.RequestorEmail || requestDetail?.UserEmail}</span></div>
                                    }
                                    {
                                        requestDetail.CreatedDate &&
                                        <div style={{ color: 'rgba(33, 37, 41, 0.75)', padding: '0px 0px 10px 0px' }}><span style={{ fontWeight: 'bold' }}>Created Date: </span><span className="_wg-exclude">{requestDetail.CreatedDate}</span></div>
                                    }
                                    {
                                        (requestDetail.ActionDate || requestDetail.UpdatedDate) &&
                                        <div style={{ color: 'rgba(33, 37, 41, 0.75)', padding: '0px 0px 10px 0px' }}><span style={{ fontWeight: 'bold' }}>Updated Date: </span><span className="_wg-exclude">{requestDetail.ActionDate || requestDetail.UpdatedDate}</span></div>
                                    }
                                    {
                                        (requestDetail.comment || requestDetail.DcrComments) &&
                                        <div style={{ color: 'rgba(33, 37, 41, 0.75)', padding: '0px 0px 10px 0px' }}><span style={{ fontWeight: 'bold' }}>Requester Comment: </span><span className='_wg-exclude'>{requestDetail.comment ||  requestDetail.DcrComments}</span></div>
                                    }
                                    {
                                        ( CONSTANT.DCR_ACTIONED_STATE.includes(requestDetail?.status) || CONSTANT.DCR_ACTIONED_STATE.includes(requestDetail?.DcrStatus)) &&
                                        <div style={{ color: 'rgba(33, 37, 41, 0.75)', padding: '0px 0px 10px 0px;' }}><span style={{ fontWeight: 'bold' }}>Reviewer Comment: </span><span className='_wg-exclude'>{requestDetail.ActionComment ||  requestDetail.ReviewerComments}</span></div>
                                    }
                                </div>
                            </div>


                            <div className='row' style={{ paddingTop: "4%", paddingBottom:'4%'}} >
                                <div className='col-6'>
                                    <h4 id="merge-text">Winner Profile</h4>
                                    <DummyCard details={winnerDetail} gotoDetails={() => goToDetails}> </DummyCard>
                                </div>
                                <div className='col-6'>
                                    <h4 id="merge-text">Loser Profile</h4>
                                    <DummyCard details={loserDetail} gotoDetails={() => goToDetails} className="mb-5"> </DummyCard>
                                </div>

                            </div>
                        </div>

                    ) : <Profile noCountryAccess="true"></Profile>
                }

            </>
        }

        {
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={open}

            >
                <ProgressBar />
            </Backdrop>
        }


        {errorFlag &&

            <div className="d-flex justify-content-center extra-margin-top">
                <Alert severity="error" className='container'>
                    <AlertTitle>{errorMsg} !</AlertTitle>
                </Alert>
            </div>
        }

        {noData &&
            <div className="extra-margin-top-less container w-80 body-height min-widths">
                <Alert severity="error" className='container'>
                    <AlertTitle>No data found !</AlertTitle>
                </Alert>
            </div>
        }


    </div>

    );
}

export default TrackMergeDetail;
